import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { ListResponse } from '../models/list-response.model';
import { ModerationInspiration, ModerationRecipe, ModerationReviewMessage } from '../models/recipe.models';

@Injectable({ providedIn: 'root' })
export class ModerationService {
  private readonly http = inject(HttpClient);

  getRecipes(status = 'REVIEW', page = 0, size = 20): Observable<ListResponse<ModerationRecipe>> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', page)
      .set('size', size);

    return this.http.get<ListResponse<ModerationRecipe>>(`${API_BASE_URL}/v1/management/moderation/recipes`, { params });
  }

  updateRecipeStatus(recipeId: number, status: 'APPROVED' | 'DENIED', reason?: string): Observable<void> {
    let params = new HttpParams().set('status', status);
    const normalizedReason = reason?.trim();
    if (normalizedReason) {
      params = params.set('reason', normalizedReason);
    }
    return this.http.put<void>(`${API_BASE_URL}/v1/management/moderation/recipes/${recipeId}`, null, { params });
  }

  getInspirations(status = 'REVIEW', page = 0, size = 20): Observable<ListResponse<ModerationInspiration>> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', page)
      .set('size', size);

    return this.http.get<ListResponse<ModerationInspiration>>(
      `${API_BASE_URL}/v1/management/moderation/inspirations`,
      { params }
    );
  }

  updateInspirationStatus(inspirationId: number, status: 'APPROVED' | 'DENIED'): Observable<ModerationInspiration> {
    const params = new HttpParams().set('status', status);
    return this.http.put<ModerationInspiration>(
      `${API_BASE_URL}/v1/management/moderation/inspirations/${inspirationId}`,
      null,
      { params }
    );
  }

  getReviewMessages(page = 0, size = 20): Observable<ListResponse<ModerationReviewMessage>> {
    const params = new HttpParams()
      .set('page', page)
      .set('size', size);

    return this.http.get<ListResponse<ModerationReviewMessage>>(
      `${API_BASE_URL}/v1/management/moderation/reviews/messages`,
      { params }
    );
  }

  updateReviewMessageStatus(reviewId: number, status: 'APPROVED' | 'DENIED'): Observable<ModerationReviewMessage> {
    const params = new HttpParams().set('status', status);
    return this.http.put<ModerationReviewMessage>(
      `${API_BASE_URL}/v1/management/moderation/reviews/${reviewId}/message`,
      null,
      { params }
    );
  }
}
